import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getReportData = api(({ measure } = {}) =>
    query(
        gql`
            query getReportData($measure: String!) {
                getReportData(measure: $measure)
            }
        `,
        { measure },
        { returns: "getReportData" }
    )
)
